/* eslint-disable no-unused-expressions */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Loading from "../../../components/shared/loading/Loading";
import { deleteData } from "../../../hooks/delete";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl } from "../../../utility/Constant";
import BoardCard from "./BoardCard";

const BoardListPage = () => {
  const { boardApi } = apiPath;
  const { clientDirectors } = clientSideUrl;
  const [certificateListData, certificateListLoading] = useFetch(boardApi);
  const [filteredData, setFilteredData] = useState();

  useEffect(() => {
    setFilteredData(certificateListData?.filter((item) => !item.slug));
  }, [certificateListData]);

  if (certificateListLoading) {
    return <Loading />;
  }

  async function handleSingleDelete(id) {
    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(boardApi, id);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?._id?.length > 0;
  }

  return (
    <div>
      <div className="mb-2 w-full text-right font-semibold text-sm">
        <Link
          className="text-blue-600 hover:text-blue-500"
          to={clientDirectors}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <h1 className="font-oswald font-bold text-2xl mb-8">
        BOARD OF DIRECTORS
      </h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
        <BoardCard />
        {filteredData.map((item, idx) => (
          <BoardCard
            key={idx}
            project={item}
            user={"admin"}
            handleSingleDelete={handleSingleDelete}
          />
        ))}
      </div>
    </div>
  );
};

export default BoardListPage;
